import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClassroomsHotspot from '../components/hotspots/ClassroomsHotspot';
import ShippingHotspot from '../components/hotspots/ShippingHotspot';
import GiftShopHotspot from '../components/hotspots/GiftShopHotspot';

function MainCampus() {
  const navigate = useNavigate();

  return (
    <div className="page mainCampusPage">
      <div className="page-header">Main Campus</div>

      <div className="text-blocks">
        <div className="std-text">
          Power your campus with a modern F&amp;B experience through a suite of software
          solutions for higher education environments that focuses on the diverse preferences
          of your student and faculty population with touch-free transactions.
        </div>
        <div className="std-text">
          Automate the food ordering experience and get real-time F&amp;B operational
          insights.
        </div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus')}>
        <img src="/assets/higher-ed/agilysys-wordmark.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
      </div>

      <div className="main-campus-map">
        <div className="classrooms">
          <ClassroomsHotspot onClick={() => navigate('/main-campus/classrooms')} />
        </div>
        <div className="shipping">
          <ShippingHotspot onClick={() => navigate('/main-campus/shipping-receiving')} />
        </div>
        <div className="gift-shop">
          <GiftShopHotspot onClick={() => navigate('/main-campus/gift-shop')} />
        </div>
      </div>

      <div className="tap">
        <img src="/assets/higher-ed/solutions/Blue-Touch-Icon.gif" alt="" />
        <div className="tap-prompt">
          Tap on each section of the map{'\n'}To drill into the details
        </div>
      </div>
    </div>
  );
}

export default MainCampus;
